import * as React from "react";
import { HftBreakdownResults } from "../models/HftBreakdownResults";

interface Props {
  hftBreakdownResults?: HftBreakdownResults
}

const SvgHftTable = (props: Props) => (
  <svg width={348.484} height={98.451} viewBox="0 0 92.203 26.049">
    <path
      fill="#62a669"
      stroke="#428649"
      strokeWidth={0.128}
      d="M61.448.064H92.14v6.482H61.448z"
    />
    <path
      fill={props.hftBreakdownResults.hftAct.style.backgroundColor.toString()}
      stroke="#ccc"
      strokeWidth={0.128}
      d="M61.448 6.546H92.14v6.482H61.448z"
    />
    <path
      fill="#62a669"
      stroke="#428649"
      strokeWidth={0.128}
      d="M30.756.064h30.692v6.482H30.756z"
    />
    <path
      fill={props.hftBreakdownResults.hftLs.style.backgroundColor.toString()}
      stroke="#ccc"
      strokeWidth={0.128}
      d="M30.756 6.546h30.692v6.482H30.756z"
    />
    <path
      fill="#62a669"
      stroke="#428649"
      strokeWidth={0.128}
      d="M.064.064h30.692v6.482H.064z"
    />
    <path
      fill={props.hftBreakdownResults.hftIn.style.backgroundColor.toString()}
      stroke="#ccc"
      strokeWidth={0.128}
      d="M.064 6.546h30.692v6.482H.064z"
    />
    <path
      fill="#62a669"
      stroke="#428649"
      strokeWidth={0.111}
      d="M46.102 13.029H69.12v6.482H46.1z"
    />
    <path
      fill={props.hftBreakdownResults.hftMin.style.backgroundColor.toString()}
      stroke="#ccc"
      strokeWidth={0.111}
      d="M46.102 19.511H69.12v6.482H46.1z"
    />
    <path
      fill="#62a669"
      stroke="#428649"
      strokeWidth={0.111}
      d="M23.083 13.029h23.019v6.482h-23.02z"
    />
    <path
      fill={props.hftBreakdownResults.hftSpt2.style.backgroundColor.toString()}
      stroke="#ccc"
      strokeWidth={0.111}
      d="M23.083 19.511h23.019v6.482h-23.02z"
    />
    <path
      fill="#62a669"
      stroke="#428649"
      strokeWidth={0.111}
      d="M.064 13.029h23.019v6.482H.063z"
    />
    <path
      fill={props.hftBreakdownResults.hftSpt1.style.backgroundColor.toString()}
      stroke="#ccc"
      strokeWidth={0.111}
      d="M.064 19.511h23.019v6.482H.063z"
    />
    <path
      fill="#62a669"
      stroke="#428649"
      strokeWidth={0.111}
      d="M69.12 13.029h23.02v6.482H69.12z"
    />
    <path
      fill={props.hftBreakdownResults.hftMact.style.backgroundColor.toString()}
      stroke="#ccc"
      strokeWidth={0.111}
      d="M69.12 19.511h23.02v6.482H69.12z"
    />
    <text
      style={{
        lineHeight: 1.25,
        fontVariantLigatures: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontFeatureSettings: "normal",
        textAlign: "start"
      }}
      x={-448.075}
      y={13.874}
      fontWeight={400}
      fontSize={4.233}
      fontFamily="Arial"
      letterSpacing={0}
      wordSpacing={0}
      fill="#fff"
      strokeWidth={0.265}
      transform="translate(489.09 -9.565)"
    >
      <tspan
        x={-448.075}
        y={13.874}
        style={{
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontVariantNumeric: "normal",
          fontFeatureSettings: "normal",
          textAlign: "start"
        }}
      >
        {"HFT"}
      </tspan>
    </text>
    <text
      style={{
        lineHeight: 1.25,
        fontVariantLigatures: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontFeatureSettings: "normal",
        textAlign: "start"
      }}
      x={-439.966}
      y={14.996}
      fontWeight={400}
      fontSize={3.175}
      fontFamily="Arial"
      letterSpacing={0}
      wordSpacing={0}
      fill="#fff"
      strokeWidth={0.265}
      transform="translate(489.09 -9.565)"
    >
      <tspan
        x={-439.966}
        y={14.996}
        style={{
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontVariantNumeric: "normal",
          fontFeatureSettings: "normal",
          textAlign: "start"
        }}
      >
        {"LS"}
      </tspan>
    </text>
    <text
      style={{
        lineHeight: 1.25,
        fontVariantLigatures: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontFeatureSettings: "normal",
        textAlign: "start"
      }}
      x={-478.003}
      y={14.01}
      fontWeight={400}
      fontSize={4.233}
      fontFamily="Arial"
      letterSpacing={0}
      wordSpacing={0}
      fill="#fff"
      strokeWidth={0.265}
      transform="translate(489.09 -9.565)"
    >
      <tspan
        x={-478.003}
        y={14.01}
        style={{
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontVariantNumeric: "normal",
          fontFeatureSettings: "normal",
          textAlign: "start"
        }}
      >
        {"HFT"}
      </tspan>
    </text>
    <text
      style={{
        lineHeight: 1.25,
        fontVariantLigatures: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontFeatureSettings: "normal",
        textAlign: "start"
      }}
      x={-469.894}
      y={15.133}
      fontWeight={400}
      fontSize={3.175}
      fontFamily="Arial"
      letterSpacing={0}
      wordSpacing={0}
      fill="#fff"
      strokeWidth={0.265}
      transform="translate(489.09 -9.565)"
    >
      <tspan
        x={-469.894}
        y={15.133}
        style={{
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontVariantNumeric: "normal",
          fontFeatureSettings: "normal",
          textAlign: "start"
        }}
      >
        {"IN"}
      </tspan>
    </text>
    <text
      style={{
        lineHeight: 1.25,
        
        fontVariantLigatures: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontFeatureSettings: "normal",
        textAlign: "start"
      }}
      x={-418.671}
      y={13.851}
      fontWeight={400}
      fontSize={4.233}
      fontFamily="Arial"
      letterSpacing={0}
      wordSpacing={0}
      fill="#fff"
      strokeWidth={0.265}
      transform="translate(489.09 -9.565)"
    >
      <tspan
        x={-418.671}
        y={13.851}
        style={{
          
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontVariantNumeric: "normal",
          fontFeatureSettings: "normal",
          textAlign: "start"
        }}
      >
        {"HFT"}
      </tspan>
    </text>
    <text
      style={{
        lineHeight: 1.25,
        
        fontVariantLigatures: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontFeatureSettings: "normal",
        textAlign: "start"
      }}
      x={-410.562}
      y={14.973}
      fontWeight={400}
      fontSize={3.175}
      fontFamily="Arial"
      letterSpacing={0}
      wordSpacing={0}
      fill="#fff"
      strokeWidth={0.265}
      transform="translate(489.09 -9.565)"
    >
      <tspan
        x={-410.562}
        y={14.973}
        style={{
          
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontVariantNumeric: "normal",
          fontFeatureSettings: "normal",
          textAlign: "start"
        }}
      >
        {"ACT"}
      </tspan>
    </text>
    <text
      style={{
        lineHeight: 1.25,
        
        fontVariantLigatures: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontFeatureSettings: "normal",
        textAlign: "start"
      }}
      x={-483.952}
      y={26.721}
      fontWeight={400}
      fontSize={4.233}
      fontFamily="Arial"
      letterSpacing={0}
      wordSpacing={0}
      fill="#fff"
      strokeWidth={0.265}
      transform="translate(489.09 -9.565)"
    >
      <tspan
        x={-483.952}
        y={26.721}
        style={{
          
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontVariantNumeric: "normal",
          fontFeatureSettings: "normal",
          textAlign: "start"
        }}
      >
        {"HFT"}
      </tspan>
    </text>
    <text
      style={{
        lineHeight: 1.25,
        
        fontVariantLigatures: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontFeatureSettings: "normal",
        textAlign: "start"
      }}
      x={-475.842}
      y={27.844}
      fontWeight={400}
      fontSize={3.175}
      fontFamily="Arial"
      letterSpacing={0}
      wordSpacing={0}
      fill="#fff"
      strokeWidth={0.265}
      transform="translate(489.09 -9.565)"
    >
      <tspan
        x={-475.842}
        y={27.844}
        style={{
          
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontVariantNumeric: "normal",
          fontFeatureSettings: "normal",
          textAlign: "start"
        }}
      >
        {"SPT1"}
      </tspan>
    </text>
    <text
      style={{
        lineHeight: 1.25,
        
        fontVariantLigatures: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontFeatureSettings: "normal",
        textAlign: "start"
      }}
      x={-461.594}
      y={26.777}
      fontWeight={400}
      fontSize={4.233}
      fontFamily="Arial"
      letterSpacing={0}
      wordSpacing={0}
      fill="#fff"
      strokeWidth={0.265}
      transform="translate(489.09 -9.565)"
    >
      <tspan
        x={-461.594}
        y={26.777}
        style={{
          
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontVariantNumeric: "normal",
          fontFeatureSettings: "normal",
          textAlign: "start"
        }}
      >
        {"HFT"}
      </tspan>
    </text>
    <text
      style={{
        lineHeight: 1.25,
        
        fontVariantLigatures: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontFeatureSettings: "normal",
        textAlign: "start"
      }}
      x={-453.485}
      y={27.9}
      fontWeight={400}
      fontSize={3.175}
      fontFamily="Arial"
      letterSpacing={0}
      wordSpacing={0}
      fill="#fff"
      strokeWidth={0.265}
      transform="translate(489.09 -9.565)"
    >
      <tspan
        x={-453.485}
        y={27.9}
        style={{
          
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontVariantNumeric: "normal",
          fontFeatureSettings: "normal",
          textAlign: "start"
        }}
      >
        {"SPT2"}
      </tspan>
    </text>
    <text
      style={{
        lineHeight: 1.25,
        
        fontVariantLigatures: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontFeatureSettings: "normal",
        textAlign: "start"
      }}
      x={-437.484}
      y={26.766}
      fontWeight={400}
      fontSize={4.233}
      fontFamily="Arial"
      letterSpacing={0}
      wordSpacing={0}
      fill="#fff"
      strokeWidth={0.265}
      transform="translate(489.09 -9.565)"
    >
      <tspan
        x={-437.484}
        y={26.766}
        style={{
          
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontVariantNumeric: "normal",
          fontFeatureSettings: "normal",
          textAlign: "start"
        }}
      >
        {"HFT"}
      </tspan>
    </text>
    <text
      style={{
        lineHeight: 1.25,
        
        fontVariantLigatures: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontFeatureSettings: "normal",
        textAlign: "start"
      }}
      x={-429.375}
      y={27.889}
      fontWeight={400}
      fontSize={3.175}
      fontFamily="Arial"
      letterSpacing={0}
      wordSpacing={0}
      fill="#fff"
      strokeWidth={0.265}
      transform="translate(489.09 -9.565)"
    >
      <tspan
        x={-429.375}
        y={27.889}
        style={{
          
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontVariantNumeric: "normal",
          fontFeatureSettings: "normal",
          textAlign: "start"
        }}
      >
        {"MIN"}
      </tspan>
    </text>
    <text
      style={{
        lineHeight: 1.25,
        
        fontVariantLigatures: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontFeatureSettings: "normal",
        textAlign: "start"
      }}
      x={-417.095}
      y={26.723}
      fontWeight={400}
      fontSize={4.233}
      fontFamily="Arial"
      letterSpacing={0}
      wordSpacing={0}
      fill="#fff"
      strokeWidth={0.265}
      transform="translate(489.09 -9.565)"
    >
      <tspan
        x={-417.095}
        y={26.723}
        style={{
          
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontVariantNumeric: "normal",
          fontFeatureSettings: "normal",
          textAlign: "start"
        }}
      >
        {"HFT"}
      </tspan>
    </text>
    <text
      style={{
        lineHeight: 1.25,
        
        fontVariantLigatures: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontFeatureSettings: "normal",
        textAlign: "start"
      }}
      x={-408.986}
      y={27.845}
      fontWeight={400}
      fontSize={3.175}
      fontFamily="Arial"
      letterSpacing={0}
      wordSpacing={0}
      fill="#fff"
      strokeWidth={0.265}
      transform="translate(489.09 -9.565)"
    >
      <tspan
        x={-408.986}
        y={27.845}
        style={{
          
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontVariantNumeric: "normal",
          fontFeatureSettings: "normal",
          textAlign: "start"
        }}
      >
        {"MACT"}
      </tspan>
    </text>
    <text
      style={{
        lineHeight: 1.25,
        
      }}
      x={-475.135}
      y={20.345}
      fontWeight={400}
      fontSize={3.528}
      fontFamily="Arial"
      letterSpacing={0}
      wordSpacing={0}
      strokeWidth={0.265}
      transform="translate(489.09 -9.565)"
    >
      <tspan
        x={-475.135}
        y={20.345}
        style={{
          
        }}
      >
        {props.hftBreakdownResults.hftIn.value}
      </tspan>
    </text>
    <text
      style={{
        lineHeight: 1.25,
        
      }}
      x={-444.752}
      y={20.533}
      fontWeight={400}
      fontSize={3.528}
      fontFamily="Arial"
      letterSpacing={0}
      wordSpacing={0}
      strokeWidth={0.265}
      transform="translate(489.09 -9.565)"
    >
      <tspan
        x={-444.752}
        y={20.533}
        style={{
          
        }}
      >
        {props.hftBreakdownResults.hftLs.value}
      </tspan>
    </text>
    <text
      style={{
        lineHeight: 1.25,
        
      }}
      x={-413.266}
      y={20.4}
      fontWeight={400}
      fontSize={3.528}
      fontFamily="Arial"
      letterSpacing={0}
      wordSpacing={0}
      strokeWidth={0.265}
      transform="translate(489.09 -9.565)"
    >
      <tspan
        x={-413.266}
        y={20.4}
        style={{
          
        }}
      >
        {props.hftBreakdownResults.hftAct.value}
      </tspan>
    </text>
    <text
      style={{
        lineHeight: 1.25,
        
      }}
      x={-410.356}
      y={33.365}
      fontWeight={400}
      fontSize={3.528}
      fontFamily="Arial"
      letterSpacing={0}
      wordSpacing={0}
      strokeWidth={0.265}
      transform="translate(489.09 -9.565)"
    >
      <tspan
        x={-410.356}
        y={33.365}
        style={{
          
        }}
      >
        {props.hftBreakdownResults.hftMact.value}
      </tspan>
    </text>
    <text
      style={{
        lineHeight: 1.25,
        
      }}
      x={-433.11}
      y={33.365}
      fontWeight={400}
      fontSize={3.528}
      fontFamily="Arial"
      letterSpacing={0}
      wordSpacing={0}
      strokeWidth={0.265}
      transform="translate(489.09 -9.565)"
    >
      <tspan
        x={-433.11}
        y={33.365}
        style={{
          
        }}
      >
        {props.hftBreakdownResults.hftMin.value}
      </tspan>
    </text>
    <text
      style={{
        lineHeight: 1.25,
        
      }}
      x={-455.467}
      y={33.497}
      fontWeight={400}
      fontSize={3.528}
      fontFamily="Arial"
      letterSpacing={0}
      wordSpacing={0}
      strokeWidth={0.265}
      transform="translate(489.09 -9.565)"
    >
      <tspan
        x={-455.467}
        y={33.497}
        style={{
          
        }}
      >
        {props.hftBreakdownResults.hftSpt2.value}
      </tspan>
    </text>
    <text
      style={{
        lineHeight: 1.25,
        
      }}
      x={-479.147}
      y={33.497}
      fontWeight={400}
      fontSize={3.528}
      fontFamily="Arial"
      letterSpacing={0}
      wordSpacing={0}
      strokeWidth={0.265}
      transform="translate(489.09 -9.565)"
    >
      <tspan
        x={-479.147}
        y={33.497}
        style={{
          
        }}
      >
        {props.hftBreakdownResults.hftSpt1.value}
      </tspan>
    </text>
  </svg>
);

export default SvgHftTable;

